import { memo } from 'react'
import { Box, Typography } from '@mui/material'

/**
 * Custom tooltip component used for timeline markers
 * Shows a title and a secondary instruction based on the marker type
 */
const CustomTooltip = memo(
  ({ title, forRemark = false, developerTag = false }) => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '5px'
        }}
      >
        <Typography sx={{ color: 'var(--common-white)' }}>{title}</Typography>
        <Typography fontSize={14} sx={{ color: 'var(--common-white)' }}>
          {developerTag
            ? 'click on the icon to view the developer tag'
            : forRemark
              ? 'click on the icon to view the evidence'
              : 'click on the icon to view the remark'}
        </Typography>
      </Box>
    )
  }
)

export default CustomTooltip
